import { personOptions, SearchSelect } from './SearchSelect';

export type Audience = 'ministerio' | 'elegidos' | 'iglesia';

/** Texto corto de a quién se convocó (para listas y fichas). */
export function audienceLabel(audience: Audience, ministry: string, count: number): string {
  if (audience === 'iglesia') return 'Toda la iglesia';
  if (audience === 'ministerio') return `Todo ${ministry}`;
  return count === 1 ? '1 persona convocada' : `${count} personas convocadas`;
}

/**
 * ¿A quién se convoca? Base común de Ensayos (Alabanza) y Jornadas (Oración):
 * todo el ministerio (siempre los mismos), solo algunos (se eligen cada vez) o toda la iglesia.
 * Solo los convocados lo ven en su Agenda (todos, si es para toda la iglesia).
 */
export function ConvocationFields({
  idPrefix,
  ministry,
  people,
  audience,
  chosen,
  onChange,
}: {
  idPrefix: string;
  /** Nombre del ministerio (Alabanza, Oración). */
  ministry: string;
  people: { personId: string; name: string }[];
  audience: Audience;
  chosen: string[];
  onChange: (next: { audience: Audience; chosen: string[] }) => void;
}) {
  const nameOf = (id: string) => people.find((p) => p.personId === id)?.name ?? 'Persona';
  const options: [Audience, string, string][] = [
    ['ministerio', `Todo ${ministry}`, 'Siempre los mismos: todos los integrantes del ministerio.'],
    ['elegidos', 'Solo algunos', 'Eliges a quiénes convocas esta vez.'],
    ['iglesia', 'Toda la iglesia', 'Aparece en la Agenda de todos.'],
  ];
  return (
    <fieldset className="convocation">
      <legend>¿A quién se convoca?</legend>
      {options.map(([value, label, hint]) => (
        <label key={value} className="check convocation__option">
          <input type="radio" name={`${idPrefix}-audience`} checked={audience === value} onChange={() => onChange({ audience: value, chosen })} />
          <span>
            <strong>{label}</strong>
            <span className="small muted"> · {hint}</span>
          </span>
        </label>
      ))}
      {audience === 'elegidos' ? (
        <div className="convocation__pick">
          <div className="field">
            <label htmlFor={`${idPrefix}-pick`}>Agregar a alguien</label>
            <SearchSelect
              id={`${idPrefix}-pick`}
              value=""
              placeholder="Escribe un nombre…"
              options={personOptions(people.filter((p) => !chosen.includes(p.personId)))}
              onChange={(id) => id && onChange({ audience, chosen: [...chosen, id] })}
            />
          </div>
          {chosen.length ? (
            <ul className="chips" aria-label="Convocados">
              {chosen.map((id) => (
                <li key={id} className="chip">
                  {nameOf(id)}
                  <button type="button" className="chip__remove" aria-label={`Quitar a ${nameOf(id)}`} onClick={() => onChange({ audience, chosen: chosen.filter((x) => x !== id) })}>
                    ×
                  </button>
                </li>
              ))}
            </ul>
          ) : (
            <p className="small muted">Todavía no eliges a nadie.</p>
          )}
          <p className="small muted">Quien dirige el ministerio siempre lo ve en su agenda.</p>
        </div>
      ) : null}
    </fieldset>
  );
}
